/**
 * Aléatoire du site. Adossé à `crypto.getRandomValues` quand il est disponible
 * — pas pour des raisons cryptographiques (personne n'attaque un tirage de
 * skin) mais parce que `Math.random` est mal réparti sur certains moteurs et
 * que le tirage du skin est la première chose que voit le visiteur.
 * Repli sur `Math.random` si l'API manque (vieux WebView, contexte non sécurisé).
 */

const cryptoSource: Crypto | undefined =
  typeof globalThis.crypto !== 'undefined' && typeof globalThis.crypto.getRandomValues === 'function'
    ? globalThis.crypto
    : undefined;

/** Entier uniforme dans [0, max[. Renvoie 0 si `max` <= 0. */
export function randomInt(max: number): number {
  if (!Number.isFinite(max) || max <= 0) return 0;
  const bound = Math.floor(max);
  if (bound === 1) return 0;

  if (cryptoSource) {
    // Rejet des valeurs de la zone de débordement pour rester uniforme.
    const limit = Math.floor(0x100000000 / bound) * bound;
    const buf = new Uint32Array(1);
    for (let attempt = 0; attempt < 8; attempt += 1) {
      cryptoSource.getRandomValues(buf);
      const value = buf[0] ?? 0;
      if (value < limit) return value % bound;
    }
  }
  return Math.floor(Math.random() * bound);
}

/** Élément au hasard d'un tableau non vide. */
export function pick<T>(items: readonly T[], fallback: T): T {
  if (items.length === 0) return fallback;
  return items[randomInt(items.length)] ?? fallback;
}
